import { useCallback, useState, type CSSProperties, type MouseEvent } from 'react';
import { Tooltip } from 'antd';
import styled from '@emotion/styled';

import { colorConstants } from 'config/colorConstants';

type TwoLineCellTextProps = {
    text: string;
    className?: string;
    style?: CSSProperties;
};

const OVERFLOW_TOOLTIP_INNER_STYLE = {
    backgroundColor: colorConstants.blackTitle,
    color: colorConstants.white,
} as const;

const StyledTwoLineText = styled.span`
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-word;
`;

const TwoLineCellText = ({ text, className, style }: TwoLineCellTextProps) => {
    const [isOverflowed, setIsOverflowed] = useState(false);

    const handleMouseEnter = useCallback((event: MouseEvent<HTMLSpanElement>) => {
        const element = event.currentTarget;
        setIsOverflowed(element.scrollHeight > element.clientHeight + 1);
    }, []);

    return (
        <Tooltip
            title={isOverflowed ? text : undefined}
            overlayInnerStyle={OVERFLOW_TOOLTIP_INNER_STYLE}
            getPopupContainer={() => document.body}
        >
            <StyledTwoLineText className={className} style={style} onMouseEnter={handleMouseEnter}>
                {text}
            </StyledTwoLineText>
        </Tooltip>
    );
};

export default TwoLineCellText;
